import instObj from '@/backend/axios-instances'

const resource = "/workstep"
const instance = instObj.baseInstance

export default {
  get(workStepId, parameters) {
    return instance.get(`${resource}/${workStepId}`, { params: parameters });
  },
  put(workStepId, data, parameters) {
    return instance.put(`${resource}/${workStepId}`, data, { params: parameters });
  },
  delete(workStepId) {
    return instance.delete(`${resource}/${workStepId}`);
  }
}
